// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fXZc","textarea":"styles_textarea__2XN_5"};